export const PageTitleConstants = {
  //Strona główna
  Home: "Strona główna",

  //Logowanie
  Login: "Logowanie",
  ForgotPassword: "Zapomniałem hasła",
  ResetPassword: "Ponowne ustawienie hasła",

  // Użytkownicy
  UserList: "Użytkownicy",

  //Pytania
  QuestionAdd: "Dodawanie pytania",
  QuestionEdit: "Edycja pytania",
  QuestionList: "Pytania",

  //Ankiety
  QuestionnaireAdd: "Dodawanie ankiety",
  QuestionnaireEdit: "Edycja ankiety",
  QuestionnaireList: "Ankiety",

  //Strony
  PageAdd: "Dodawanie strony",
  PageEdit: "Edycja strony",
  PageList: "Strony",
  //Kalendarz
  Calendar: "Kalendarz",
  CalendarForm: "Formularz",

  // Meetings
  Meetings: "Moje spotkania",

  Autoanalysis: "Autoanaliza",
  Survey: "Uzupełnianie autoanalizy",
  ApplicationForm: "Zgłoszenie",
  ContractForm: "Umowa",
  ContractFormv2: "Druga umowa o dofinansowanie",
  CompletingBalanceSheetOfModuleFirst: "Samoocena",
  CompletingBalanceSheetOfModuleFirstByAdvisor:
    "Uzupełnianie samooceny przez doradcę",
  Store: "Oferta",
  StoreSummary: "Podsumowanie",
  StoreEdit: "Edycja",
  StoreExclusive: "Oferta ekskluzywna",
  StoreExclusiveSummary: "Oferta ekskluzywna podsumowanie",
  CompletingBalanceSheetOfModuleSecond: "Twój cel rozwojowy",
  CompletingBalanceSheetOfModuleSecondv2: "Twój cel rozwojowy - drugie zamówienie",
  OrderingVouchers: "Zamówienia bonów",
  EndWithOrder: "Koniec procesu (zamówione bony)",
  EndWithoutOrder: "Koniec procesu (bez zamówienia bonów)",
  NewPassword: "Utworzenie hasła",
};
